/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, relative: NonNullable<unknown> }} Chat_Tool_Confirm_Expires_OnInputs */



/**
* | output |
* | --- |
* | "Waiting for approval — expires on {date} ({relative})" |
*
* @param {Chat_Tool_Confirm_Expires_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_expires_on = /** @type {((inputs: Chat_Tool_Confirm_Expires_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Expires_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wartet auf Freigabe – läuft am ${i?.date} ab (${i?.relative})`)
	return /** @type {LocalizedString} */ (`Waiting for approval — expires on ${i?.date} (${i?.relative})`)
});